import URI from 'urijs'
import Vue from 'vue'
import axios from 'axios'
import { config } from '@/plugins/env.config'

async function getDoctorInformation(doctor, attemptNumber = 1) {
  const getDoctorInformationUri = new URI(config.apiBaseUrl)
  getDoctorInformationUri.segment('providers')
  getDoctorInformationUri.segment('v2')
  getDoctorInformationUri.segment('providers')
  getDoctorInformationUri.segment(doctor)

  try {
    return await Vue.prototype.$http.get(getDoctorInformationUri.toString())
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getDoctorInformation(doctor, attemptNumber + 1)
    }

    throw error
  }
}

async function getProviderRegistrationRequest(email, attemptNumber = 1) {
  const getProviderRegistrationRequestUri = new URI(config.apiBaseUrl)
  getProviderRegistrationRequestUri.segment('providers')
  getProviderRegistrationRequestUri.segment('v2')
  getProviderRegistrationRequestUri.segment('registration-requests')

  getProviderRegistrationRequestUri.addSearch('email_address', email)

  const getTokenHeaders = {
    Authorization: `Bearer ${localStorage.getItem('clientToken')}`
  }

  try {
    return await axios.get(getProviderRegistrationRequestUri.toString(), {
      headers: getTokenHeaders
    })
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getProviderRegistrationRequest(email, attemptNumber + 1)
    }

    throw error
  }

}

async function updateProviderProfile(providerSlug, payload, attemptNumber = 1) {
  const updateProviderProfileUri = new URI(config.apiBaseUrl)
  updateProviderProfileUri.segment('providers')
  updateProviderProfileUri.segment('v2')
  updateProviderProfileUri.segment('providers')
  updateProviderProfileUri.segment(providerSlug)

  try {
    return await Vue.prototype.$http.patch(updateProviderProfileUri.toString(), payload)
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return updateProviderProfile(providerSlug, payload, attemptNumber + 1)
    }

    throw error
  }
}

export {
  getDoctorInformation,
  getProviderRegistrationRequest,
  updateProviderProfile
}